Monitoring.Views ||= {}

class Monitoring.Views.TicketActionsEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/rules/ticket_actions_edit"]

  className: 'social-content-actions'

  events:
    'change #unassign-ticket': 'onChangeUnassignTicket'
    'change #unassign-operator-check': 'onCheckUnassignOperator'
    'change #unassign-all-check': 'onCheckUnassignAll'
    'change #assign-ticket': 'onChangeAssignTicket'
    'change #assign-to-operator-check': 'onCheckAssignOperator'
    'change #assign-to-group-check': 'onCheckAssignGroup'
    'change #selected-group': 'onChangeSelectedUserGroup'
    'change #selected-operator': 'onChangeSelectedOperator'
    'change #close-ticket': 'onChangeCloseTicketDecision'
    'change #prioritize-ticket': 'onChangePrioritizeTicketDecision'
    'change #priority-score': 'onChangePriority'
    'change #reply-ticket-check': 'onCheckReplyTemplate'
    'change #selected-template': 'onChangeReplyTemplate'
    'change #reply-channel': 'onChangeReplyChannel'

  initialize: (@options = {}) ->
    @ticketActions = @options.ticketActions
    @availableUserGroups = @options.availableUserGroups || []
    @availableOperators = @options.availableOperators || []
    @availableTemplates = @options.availableTemplates || []

  render: =>
    @$el.html(@template(@))
    @initializePrioritySlider()
    @onChangeAssignTicket()
    @onChangeUnassignTicket()
    @initializeReplyTemplateOptions()
    @

  getActions: ->
    @ticketActions

  onChangeUnassignTicket: =>
    unassignTicket = @$el.find('#unassign-ticket').prop('checked')
    @toggleUnassignOptions(unassignTicket)
    @trigger('changed-mandatory-field')

  toggleUnassignOptions: (unassignTicket)=>
    if unassignTicket
      @$el.find("#unassign-ticket-options").removeClass('hidden')
    else
      @$el.find("#unassign-ticket-options").addClass('hidden')
      @$el.find('#unassign-operator-check').prop('checked', false)
      @$el.find('#unassign-all-check').prop('checked', false)
      @ticketActions['unassign_operator_in_ticket_action'] = false
      @ticketActions['unassign_all_in_ticket_action'] = false
    @trigger('changed-mandatory-field')

  onCheckUnassignOperator: =>
    checked = @$el.find('#unassign-operator-check').prop('checked')
    @ticketActions['unassign_operator_in_ticket_action'] = checked
    @ticketActions['unassign_all_in_ticket_action'] = !checked
    @trigger('changed-mandatory-field')

  onCheckUnassignAll: =>
    checked = @$el.find('#unassign-all-check').prop('checked')
    @ticketActions['unassign_all_in_ticket_action'] = checked
    @ticketActions['unassign_operator_in_ticket_action'] = !checked
    @trigger('changed-mandatory-field')

  onChangeAssignTicket: =>
    assignTicket = @$el.find('#assign-ticket').prop('checked')
    @toggleAssignOptions(assignTicket)
    @trigger('changed-mandatory-field')

  toggleAssignOptions: (assignTicket)=>
    if assignTicket
      @$el.find("#assign-ticket-options").removeClass('hidden')
      @onCheckAssignGroup()
    else
      @$el.find("#assign-ticket-options").addClass('hidden')
      @disableAssignOperator()
      @disableAssignGroup()

  onCheckAssignOperator: ->
    $("#assign-to-operator-select").addClass('active')
    @disableAssignGroup()
    @trigger('changed-mandatory-field')

  onCheckAssignGroup: ->
    $("#assign-to-group-check").attr('checked', true )
    $("#assign-to-group-select").addClass('active')
    @disableAssignOperator()
    @trigger('changed-mandatory-field')

  disableAssignOperator: ->
    @disableSelection('operator', 'assign_ticket_to_operator_action')

  disableAssignGroup: ->
    @disableSelection('group', 'assign_ticket_to_users_group_action')

  disableSelection: (actionId, actionName) ->
    $("#assign-to-#{actionId}-select").removeClass('active')
    radioButton = $("#assign-to-#{actionId}-check")[0]
    if radioButton then radioButton.checked = false
    $("#selected-#{actionId}").val('').trigger("chosen:updated")
    @ticketActions[actionName] = ''

  onChangeSelectedUserGroup: (evt) =>
    userGroup = $(evt.currentTarget).find('option:selected').val();
    @ticketActions["assign_ticket_to_users_group_action"] = userGroup
    @trigger('changed-mandatory-field')

  onChangeSelectedOperator: (evt) =>
    operator = $(evt.currentTarget).find('option:selected').val();
    @ticketActions["assign_ticket_to_operator_action"] = operator
    @trigger('changed-mandatory-field')

  onChangeCloseTicketDecision: (evt) =>
    closeTicket = $(evt.currentTarget).prop('checked')
    @ticketActions["close_ticket_action"] = if closeTicket then 'close' else ''
    @trigger('changed-mandatory-field')

  onChangePrioritizeTicketDecision: (evt) =>
    prioritizeTicket = $(evt.currentTarget).prop('checked')
    priority = @$el.find('#priority-score').val()
    @ticketActions["prioritize_ticket_action"] = if prioritizeTicket then priority else ''
    @togglePrioritySlider(prioritizeTicket)

  initializePrioritySlider: =>
    prioritizeTicket = @$el.find('#prioritize-ticket').prop('checked')
    @togglePrioritySlider(prioritizeTicket)
    @$el.find('#priority-score').simpleSlider(
      range: [1, 10], snap: true, step: 1
    ).bind('slider:changed', (e, data) => @$el.find('#priority-action-number').text(data.value));

  togglePrioritySlider: (prioritizeTicket)=>
    if prioritizeTicket
      @$el.find("#prioritize-action").removeClass('hidden')
    else
      @$el.find("#prioritize-action").addClass('hidden')

  onChangePriority: (evt) =>
    priority = @$el.find('#priority-score').val()
    @ticketActions["prioritize_ticket_action"] = priority

  initializeReplyTemplateOptions: ->
    checked = @$el.find('#reply-ticket-check').prop('checked')
    if checked
      @$el.find("#reply-ticket-options").removeClass('hidden')
    else
      @$el.find("#reply-ticket-options").addClass('hidden')

  onCheckReplyTemplate: =>
    checked = @$el.find('#reply-ticket-check').prop('checked')
    @toggleReplyTicketOptions(checked)
    @trigger('changed-mandatory-field')

  toggleReplyTicketOptions: (checked)=>
    if checked
      @$el.find("#reply-ticket-options").removeClass('hidden')
      template = $('#selected-template').find('option:selected').val();
      @ticketActions['reply_predefined_template_id'] = template
      replyChannel = $('#reply-channel').find('option:selected').val();
      @ticketActions['reply_channel'] = replyChannel
    else
      @$el.find("#reply-ticket-options").addClass('hidden')
      @ticketActions['reply_predefined_template_id'] = ''
      @ticketActions['reply_channel'] = ''

  onChangeReplyTemplate: (event) =>
    template = $(event.currentTarget).find('option:selected').val();
    @ticketActions['reply_predefined_template_id'] = template
    @trigger('changed-mandatory-field')

  onChangeReplyChannel: (event) =>
    replyChannel = $(event.currentTarget).find('option:selected').val();
    @ticketActions['reply_channel'] = replyChannel

  allMandatoryFieldsAreFilled: =>
    @_replyActionValidation() && @_unassignTicketActionValidation() && @_assignTicketActionValidation()

  _replyActionValidation: ->
    selectedTemplate = @ticketActions['reply_predefined_template_id'].toString()
    if selectedTemplate
      isSelected = selectedTemplate != 0.toString()
      isAvailable = _.any(@availableTemplates, (template) -> template.id.toString() == selectedTemplate)
      isSelected && isAvailable
    else
      true

  _unassignTicketActionValidation: ->
    @_assignationActionValidation('#unassign-ticket', 'unassign_operator_in_ticket_action', 'unassign_all_in_ticket_action')

  _assignTicketActionValidation: ->
    @_assignationActionValidation('#assign-ticket', 'assign_ticket_to_operator_action', 'assign_ticket_to_users_group_action')

  _assignationActionValidation: (checkboxName, operatorAction, groupAction) ->
    actionChecked = @$el.find(checkboxName).prop('checked')
    if actionChecked
      @ticketActions[operatorAction] || @ticketActions[groupAction]
    else
      true
